import { SecondaryButton } from "@digipost/dds-buttons-react";
import { FC } from "react";
import { useSelector } from "react-redux";

import { User } from "../../../types/session";
import SigneringPostenLogo from "../../assets/images/logo/signering-posten-logo.svg";
import SigneringPostenLogoLiten from "../../assets/images/logo/signering-posten-logo-liten.svg";
import {
  SiteImproveActions,
  SiteImproveCategories,
  siteImproveEvent,
} from "../analytics/SiteImprove";
import { ReduxState } from "../infrastructure/redux/state";
import Translated from "../infrastructure/Translated";

type Props = {
  logout: () => void;
  user?: Partial<User>;
  authOK: boolean;
};

const SigneringHeader: FC<Props> = ({ authOK, logout, user }) => {
  const mode = useSelector((state: ReduxState) => state.app.mode);
  return (
    <header className={"header"}>
      <section className={"header-items-container"}>
        <a
          href="https://www.signering.posten.no/registrering/bedrift"
          className={"header-logo-link"}
        >
          <img
            src={SigneringPostenLogo}
            alt={"Logo: Posten signering"}
            className={"logo-signering logo-desktop"}
          />
          <img
            src={SigneringPostenLogoLiten}
            alt={"Logo: Posten signering"}
            className={"logo-signering logo-mobile"}
          />
        </a>
      </section>
      <section className={"header-items-container"}>
        {authOK && user && (
          <>
            <div className={"header-link enabled"}>
              <span>{`${user.firstName ?? ""} ${user.lastName ?? ""}`}</span>
            </div>
            <div className="logout-button">
              <SecondaryButton
                onClick={() => {
                  siteImproveEvent({
                    category: SiteImproveCategories.GENERAL,
                    action: SiteImproveActions.LOGOUT,
                    label: `/${mode}`,
                  });
                  return logout();
                }}
              >
                <Translated textKey="generic.logout" />
              </SecondaryButton>
            </div>
          </>
        )}
      </section>
    </header>
  );
};

export default SigneringHeader;
